import './utils/console-shim';
import './polyfills';
import { createRoot } from 'react-dom/client';
import React from 'react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';
import FlagProvider from '@unleash/proxy-client-react';
import { UnleashService } from './v2/services';
import { initRUM } from './v2/core/services/rum/rum.service';

initRUM();

const root = createRoot(document.getElementById('root'));
root.render(
  <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <FlagProvider config={UnleashService.CONFIG}>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </FlagProvider>
  </HashRouter>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
